import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';

const AboutTeaser = () => {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="flex flex-col lg:flex-row gap-16 items-center">
          
          <div className="lg:w-1/2">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <div className="inline-block px-4 py-2 rounded-full bg-blue-50 text-blue-700 font-semibold text-sm mb-6">
                Who We Are
              </div>
              <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-6 tracking-tight">
                Your Trusted Partner for <span className="text-blue-600">IT Excellence</span>
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed mb-6">
                Businex Technologies is a trusted team of elite IT strategists and software engineers. We partner closely with businesses to solve complex operational challenges, optimize system workflows, and build high-performance products that drive sustainable growth.
              </p>
              <p className="text-lg text-slate-600 leading-relaxed mb-8">
                By combining deep technical expertise with a thorough understanding of business dynamics, our seasoned experts design and deliver robust digital systems. We focus on creating high-impact solutions that build lasting trust and enable your organization to scale with confidence.
              </p>
              
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
                {['Elite Tech Strategists', 'Result-Oriented Delivery', 'Business-Focused Solutions', 'Enterprise-Grade Security'].map((item, i) => (
                  <li key={i} className="flex items-center gap-3 text-slate-700 font-medium">
                    <CheckCircle2 className="text-blue-600" size={20} />
                    {item}
                  </li>
                ))}
              </ul>

              <Link to="/about" className="inline-flex items-center justify-center gap-2 bg-slate-900 hover:bg-blue-600 text-white px-8 py-4 rounded-full font-semibold transition-colors group">
                Discover Our Story
                <ArrowRight className="group-hover:translate-x-1 transition-transform" size={20} />
              </Link>
            </motion.div>
          </div>

          <div className="lg:w-1/2 relative">
             <motion.div 
               initial={{ opacity: 0, scale: 0.9 }}
               whileInView={{ opacity: 1, scale: 1 }}
               viewport={{ once: true }}
               transition={{ duration: 0.5 }}
               className="relative rounded-3xl overflow-hidden shadow-2xl"
             >
                <div className="w-full h-[500px] bg-gradient-to-tr from-slate-800 to-slate-900 flex items-center justify-center relative overflow-hidden">
                   <div className="absolute inset-0 opacity-20 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]"></div>
                   <div className="absolute top-[-20%] left-[-10%] w-72 h-72 bg-blue-500 rounded-full blur-[100px]"></div>
                   <div className="absolute bottom-[-20%] right-[-10%] w-72 h-72 bg-indigo-500 rounded-full blur-[100px]"></div>
                   
                   <div className="relative z-10 text-center px-8">
                       <h3 className="text-4xl font-bold text-white mb-4">Expert Minds</h3>
                       <p className="text-blue-200 text-lg font-medium">Solving Complex Business Problems</p>
                    </div>
                </div>

                {/* Floating stats card */}
                <motion.div 
                  initial={{ y: 30, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.3 }}
                  className="absolute bottom-8 -left-6 bg-white p-6 rounded-2xl shadow-xl border border-slate-100 hidden md:flex items-center gap-4 z-20"
                >
                  <div className="w-14 h-14 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center font-bold text-xl shrink-0">
                    100%
                  </div>
                  <div>
                    <p className="font-bold text-slate-900 text-lg">Client Focus</p>
                    <p className="text-slate-500 text-sm">Dedicated to Business Growth</p>
                  </div>
                </motion.div>
             </motion.div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutTeaser;
